import Vue from 'vue'
import VueRouter from 'vue-router'
import comData from '@/store/common.js'
import Index from '../views/Index.vue'
import NewsDetail from '../views/NewsDetail.vue'
import ListPage from '../views/ListPage.vue'
import VideoDetail from '../views/VideoDetail.vue'
import Search from '../views/Search.vue'
import ExamDetail from '../views/ExamDetail.vue'
import Exam from '@/views/Exam.vue'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueRouter)

let routesArray = [{
    path: '/',
    name: 'Index',
    redirect: "/index"
  },
  {
    path: '/detail/:newsId',
    name: "Detail",
    component: NewsDetail
  },
  {
    path: '/videoDetail/:newsId',
    name: "VideoDetail",
    component: VideoDetail
  },
  {
    path: '/search',
    name: "Search",
    component: Search
  },
  {
    path:"/exam",
    component:Exam,
  },
  {
    path:"/exam/:newsId",
    component:ExamDetail
  },
  {
    path: '/list',
    name: "list",
    component: ListPage
  }
].concat(comData.navList)
const routes = routesArray


// {
//   path: '/about',
//   name: 'About',
//   // route level code-splitting
//   // this generates a separate chunk (about.[hash].js) for this route
//   // which is lazy-loaded when the route is visited.
//   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
// }


const router = new VueRouter({
  routes
})

export default router